import React from "react"
import styled from "styled-components"
import useFormValidation from "./useFormValidation"
import {
  BodyCopy,
  StandardContainer,
  StyledHeading,
  Button,
  SectionWrapper,
} from "../../common"

const StyledContactForm = styled(StandardContainer)`
  text-align: center;
  padding: 0 2rem;
  margin: ${(props) => props.theme.spacers.med} auto;
  > form {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .form_item {
      width: 100%;
    }
    .form_actions,
    .captcha {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media ${(props) => props.theme.breakpoints.medium} {
    > form {
      flex-direction: row;
      .form_item {
        width: calc(50% - 1rem);
      }
      .form_item.full {
        width: 100%;
      }
    }
  }

  @media ${(props) => props.theme.breakpoints.large} {
    margin: ${(props) => props.theme.spacers.large} auto;
  }
`

export const ContactForm = ({
  text_content,
  heading,
  anchor_id,
  confirmation_message,
  pageTitle,
  block_background,
}) => {
  const INITIAL_STATE = {
    formTag: pageTitle,
  }
  const { handleSubmit, handleChange, success } =
    useFormValidation(INITIAL_STATE)
  return (
    <SectionWrapper $bgColor={block_background}>
      <StyledContactForm $wrappednarrow id={anchor_id}>
        {success ? (
          <BodyCopy
            dangerouslySetInnerHTML={{
              __html: confirmation_message?.html
                ? confirmation_message?.html
                : "<h2>Thanks for dropping in your details. </h2><p>We'll be in touch in a jiffy.</p>",
            }}
          />
        ) : (
          <>
            <BodyCopy>
              <StyledHeading size="h2">{heading?.text}</StyledHeading>
              <div
                dangerouslySetInnerHTML={{ __html: text_content?.html }}
                style={{ marginBottom: "2rem" }}
              />
            </BodyCopy>

            <form
              name="lead-form"
              data-netlify="true"
              data-netlify-honeypot="bot-field"
              subject={`Trev Holdings Ltd - Thank you`}
              onSubmit={handleSubmit}
            >
              <input type="hidden" name="form-name" value="lead-form" />
              <p hidden>
                <input type="text" name="formTag" value={pageTitle} disabled />
              </p>

              <p hidden>
                <label>
                  Don’t fill this out:{" "}
                  <input name="bot-field" onChange={handleChange} />
                </label>
              </p>
              <div className="form_item">
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  required={true}
                  onChange={handleChange}
                />
              </div>
              <div className="form_item">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  required={true}
                  onChange={handleChange}
                />
              </div>
              <div className="form_item">
                <label htmlFor="company">Company</label>
                <input
                  type="text"
                  name="company"
                  id="company"
                  required="false"
                  onChange={handleChange}
                />
              </div>
              <div className="form_item">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="text"
                  name="phone"
                  id="phone"
                  required="false"
                  onChange={handleChange}
                />
              </div>
              <div className="form_item radios">
                <label htmlFor="contact_method">Prefered Contact Method</label>
                <label className="radio_container" for="contact-email">
                  Email
                  <input
                    type="radio"
                    name="contact_method"
                    value="Email"
                    onChange={handleChange}
                    id="contact-email"
                  />
                  <span className="checkmark" />
                </label>
                <label className="radio_container" htmlFor="contact-phone">
                  Phone
                  <input
                    type="radio"
                    name="contact_method"
                    value="Phone"
                    onChange={handleChange}
                    id="contact-phone"
                  />
                  <span className="checkmark" />
                </label>
              </div>
              <div className="form_item radios">
                <label htmlFor="contact_time">Preferred Time</label>
                <label className="radio_container" for="contact-morning">
                  Morning
                  <input
                    type="radio"
                    name="contact_time"
                    value="Morning"
                    onChange={handleChange}
                    id="contact-morning"
                  />
                  <span className="checkmark" />
                </label>
                <label className="radio_container" htmlFor="contact-afternoon">
                  Afternoon
                  <input
                    type="radio"
                    name="contact_time"
                    value="Afternoon"
                    onChange={handleChange}
                    id="contact-afternoon"
                  />
                  <span className="checkmark" />
                </label>
                <label className="radio_container" htmlFor="contact-evening">
                  Evening
                  <input
                    type="radio"
                    name="contact_time"
                    value="Evening"
                    onChange={handleChange}
                    id="contact-evening"
                  />
                  <span className="checkmark" />
                </label>
              </div>
              <div className="form_item">
                <label htmlFor="numberoffarms">Number of Farms</label>
                <input
                  type="number"
                  name="numberoffarms"
                  id="numberoffarms"
                  required={true}
                  onChange={handleChange}
                />
              </div>
              <div className="form_item full">
                <label htmlFor="comment">Comment</label>
                <textarea id="comment" name="comment" onChange={handleChange} />
              </div>
              {/* <div className="form_item captcha">
              <Recaptcha sitekey={process.env.SITE_RECAPTCHA_KEY} />
            </div> */}
              <div className="form_actions">
                <Button type="submit" className="form-submit">
                  Submit
                </Button>
              </div>
            </form>
          </>
        )}
      </StyledContactForm>
    </SectionWrapper>
  )
}
